import {useMutation, useQueryClient} from 'react-query';
import PatchMachineryAdvertisement from '.';
import {toast} from 'react-toastify';
import {AxiosError} from 'axios';

interface IPostMachineryAdvertisementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
  guid?: string;
}

const usePatchMachineryAdvertisement = ({
  guid,
  onSuccess,
}: IPostMachineryAdvertisementProps) => {
  const queryClient = useQueryClient();

  const data = useMutation({
    mutationFn: (payload: IMachineryAdvertisementPayload) => {
      return PatchMachineryAdvertisement(payload, guid);
    },

    onSuccess: data => {
      if (onSuccess) {
        onSuccess(data); // Passing the response to onSuccess
      }

      queryClient.invalidateQueries({queryKey: ['my-ads']}); // Invalidate personal ads
      queryClient.invalidateQueries({queryKey: ['get-store-lab-views']}); // Invalidate store ads
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return data;
};

export {usePatchMachineryAdvertisement};
